export type ConfirmDialogIdentifier =
  | 'GpDeleteContactConfirm'
  | 'QbrDocumentSaveAsConfirm'
  | 'QbrDocumentSaveConfirm'
  | 'DeleteInitiativeConfirm'
  | 'ThingsToImproveCommitmentChangeDialog'
  | 'ThingsToImproveConfirmationDialog'
  | 'ThingsToImproveIsDataInsightDialog'
  | 'ThingsToImproveExistingCategoryDialog'
  | 'ThingsToImproveWarningDialog'
  | 'ThingsToImproveDeleteDialog'
  | 'GoalItemDeleteDialog'
  | 'SignatureDropDialog'
  | 'AssortmentSaveConfirmDialog'
  | 'AssortmentDeleteConfirmDialog'
  | 'AssortmentApplicableChangeConfirmDialog'

export const unregisterConfirmDialog = (dialogIdentifier: ConfirmDialogIdentifier) => ({
  type: 'UNREGISTER_CONFIRM' as const,
  payload: dialogIdentifier,
})

export const registerConfirmDialog = (dialogIdentifier: ConfirmDialogIdentifier) => ({
  type: 'REGISTER_CONFIRM' as const,
  payload: dialogIdentifier,
})

export const showConfirmDialog = (dialogIdentifier: ConfirmDialogIdentifier) => ({
  type: 'SHOW_CONFIRM' as const,
  payload: dialogIdentifier,
})

export const hideConfirmDialog = (dialogIdentifier: ConfirmDialogIdentifier) => ({
  type: 'HIDE_CONFIRM' as const,
  payload: dialogIdentifier,
})

export type ShowConfirmDialogAction = ReturnType<typeof showConfirmDialog>
export type HideConfirmDialogAction = ReturnType<typeof hideConfirmDialog>
export type RegisterConfirmDialogAction = ReturnType<typeof registerConfirmDialog>
export type UnregisterConfirmDialogAction = ReturnType<typeof unregisterConfirmDialog>

export type ConfirmDialogActions =
  | ShowConfirmDialogAction
  | HideConfirmDialogAction
  | RegisterConfirmDialogAction
  | UnregisterConfirmDialogAction
